<template>
	<div>
		<v-container fluid pa-0>
			<v-card elevation="0">
				<v-container fluid grid-list-xl class="toolbar-container">
					<v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
						<v-toolbar color="transparent" flat elevation="0">
							<v-toolbar-title class="ml-0">
								{{ $t($route.meta.title) + " (" + totalSubscriptionCount + ")" }}
							</v-toolbar-title>
							<v-spacer></v-spacer>

							<!-- <bc-select
								v-model="filter.bucket"
								:label="`${$t('lang.bucket')}`"
								:items="bucketOptions"
								item-value="value"
								item-text="option"
								style="max-width: 105px"
								class="mt-4 mx-2"
								clearable
								multiple
								v-if="!table_view"
							></bc-select> -->
							<bc-select v-model="filter.company_id" :label="`${$t('lang.company')}`"
								:items="company_options" item-value="company_id" item-text="company"
								style="max-width: 127px" class="mt-4 mx-2" clearable v-if="!table_view"></bc-select>
							<bc-search-input v-if="!table_view" placeholder="search" style="max-width: 200px"
								v-model="textSearch" class="mx-2"></bc-search-input>

							<!-- Account dropdown for KANBAN view -->
							<bc-select v-model="filter.company_id" :label="`${$t('lang.company')}`"
								:items="company_options" item-value="company_id" item-text="company"
								style="max-width: 150px" class="mt-4 mx-2" clearable v-if="table_view"></bc-select>

							<bc-tooltip>
								<template slot="activator">
									<v-btn icon @mouseup.left="changeView()">
										<v-icon style="font-size: 28px; margin-top: 2px">view_kanban</v-icon>
									</v-btn>
								</template>
								{{ $t("lang.change_view") }}
							</bc-tooltip>

							<!-- <bc-btn-add v-if="hasPerm('subscriptions.create')" @invoke-method="invokeMethod($event)" action="openSubscriptionForm"></bc-btn-add> -->
							<bc-btn-refresh @invoke-method="refreshCurrentView(true)"></bc-btn-refresh>
							<bc-btn-mobile-nav @invoke-method="invokeMethod($event)"
								:mobile-list="mobile_list"></bc-btn-mobile-nav>
						</v-toolbar>
					</v-layout>
				</v-container>

				<bc-circle-loader v-if="loading"></bc-circle-loader>

				<v-card-text v-else :class="$bp.smallScreen ? 'pa-0' : null" v-show="!table_view">
					<v-data-table :headers="headers" :items="filteredSubscriptions"
						:no-data-text="$t('lang.no_results_matching')" hide-actions>
						<template slot="items" slot-scope="props">
							<tr class="clickable" @mouseup.left="openSubscriptionTableForm(props.item)">
								<td>{{ props.item.public_id }}</td>
								<td>{{ props.item.company_name }}</td>
								<td>${{ props.item.amount }}</td>
								<td class="text-center">{{ props.item.term_length }}</td>
								<td class="text-center">{{ props.item.period_start }}</td>
								<td class="text-center">{{ props.item.period_end }}</td>
								<td class="text-center">
									<v-chip class="br-7" small text-color="white" round
										:color="props.item.status_class">
										<span class="caption text-uppercase">{{ props.item.status }}</span>
									</v-chip>
								</td>
							</tr>
						</template>
					</v-data-table>
				</v-card-text>
			</v-card>

			<v-container class="ma-0" style="max-width: unset !important">
				<v-card class="c-border br-7" elevation="0" v-show="table_view">
					<v-card-text style="background-color: white">
						<v-layout :row="$bp.lgAndUp" :column="!$bp.lgAndUp" style="gap: 16px !important">
							<v-flex v-for="bucket in filteredBuckets" :key="bucket.key || bucket.title"
								:xs12="filteredBuckets.length === 1" :xs6="filteredBuckets.length !== 1"
								:style="{ backgroundColor: bucket.color }" class="c-border br-7">
								<v-layout column style="gap: 16px !important" class="pa-3">
									<span style="text-align: center; font-size: 24px">
										{{ bucket.title.toUpperCase() }}
										({{ getBucketSubscriptionCount(bucket) }})
									</span>
									<small style="text-align: center">{{ bucket.subtitle }}</small>

									<v-card class="pa-0 c-border br-7" elevation="0" style="background: white">
										<v-card-text class="pa-0"
											:style="bucket.items.length === 0 ? 'display: flex; justify-content: center; align-items: center;' : ''">
											<small v-if="bucket.items.length === 0">
												{{ $t("lang.no_subscriptions_found") }}
											</small>

											<v-list two-line sub-header
												style="height: calc(100vh - 355px); overflow: hidden">
												<vue-perfect-scrollbar style="max-height: 100%; overflow-y: auto">
													<v-list-tile v-for="item in bucket.items"
														:key="item.renewal_period_id" class="mb-3 pb-2 c-border-bottom"
														style="height: auto !important">
														<v-list-tile-content>
															<!-- Customer Name -->
															<v-list-tile-title class="fw-semi-bold">
																{{ item.customer_name }}
															</v-list-tile-title>

															<!-- ✅ Chip Breakdown Row -->
															<div class="chip-row">
																<v-chip v-if="Number(item.invoiced_count) > 0" small
																	class="br-7" color="green lighten-4"
																	style="margin: 1px !important">
																	<strong>{{ item.invoiced_count }}</strong>&nbsp;
																	invoiced • ${{
																		item.invoiced_amount }}
																</v-chip>

																<v-chip
																	v-if="Number(item.uninvoiced_count) > 0 && bucket.title == 'upcoming'"
																	small class="br-7" color="blue lighten-4"
																	style="margin: 1px !important">
																	<strong>{{ item.uninvoiced_count }}</strong>&nbsp;
																	remaining •
																	${{ item.uninvoiced_amount }}
																</v-chip>
															</div>

															<!-- Period Dates -->
															<v-list-tile-sub-title class="grey--text text--darken-1">
																<small>{{ item.period_start }} to {{ item.period_end
																}}</small>
															</v-list-tile-sub-title>
														</v-list-tile-content>

														<!-- Action Button -->
														<v-list-tile-action>
															<v-btn v-if="hasPerm('subscriptions.update')" icon small
																@click="openSubscriptionForm(item)">
																<v-icon>edit</v-icon>
															</v-btn>
														</v-list-tile-action>
													</v-list-tile>
												</vue-perfect-scrollbar>
											</v-list>
										</v-card-text>
									</v-card>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-card-text>
					<v-card-actions style="background-color: white">
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-container>

			<bc-dialog :value="subscription_dialog" :max-width="800">
				<v-card>
					<v-form ref="form_subscription">
						<v-card-title>
							<span class="headline">{{
								selected_subscription_renewal.renewal_period_id ? $t("lang.edit_subscription_renewal") :
									$t("lang.add_subscription_renewal")
							}}</span>
							<v-spacer></v-spacer>
							<bc-btn-dialog-close @invoke-method="invokeMethod($event)" action="closeSubscriptionDialog"
								:dialog-status="subscription_dialog"></bc-btn-dialog-close>
						</v-card-title>
						<v-card-text>
							<v-container grid-list-form>
								<v-layout row wrap>
									<!-- TOP SECTION -->
									<v-flex xs12>
										<v-card class="c-border br-7" flat>
											<v-card-text style="margin-top: 0px !important">
												<v-layout row wrap>
													<v-flex xs12 sm4>
														<div class="caption grey--text text--darken-1">Customer</div>
														<div class="subheading fw-semi-bold">
															{{ selected_subscription_renewal.customer_name || "-" }}
														</div>
														<div class="caption grey--text"
															v-if="selected_subscription_renewal.distributor_name">
															{{ selected_subscription_renewal.distributor_name }}
														</div>
													</v-flex>

													<v-flex xs12 sm4>
														<div class="caption grey--text text--darken-1">{{
															$t("lang.expiring") }}
														</div>
														<div class="subheading fw-semi-bold">
															{{
																formatDate(selected_subscription_renewal.current_period_expiring)
															}}
														</div>
														<div class="caption grey--text">
															{{
																selected_subscription_renewal.days_until_expiry != null
																	? selected_subscription_renewal.days_until_expiry + " days"
																	: ""
															}}
														</div>
													</v-flex>

													<v-flex xs12 sm4>
														<v-layout row wrap justify-end align-center>
															<div class="text-sm-left">
																<div class="caption grey--text text--darken-1"
																	style="margin-left: 6px">
																	{{ $t("lang.status") }}
																</div>

																<v-chip small text-color="white"
																	:color="statusColor(selected_subscription_renewal.lifecycle_status)"
																	class="status-chip text-uppercase">
																	{{ selected_subscription_renewal.lifecycle_status ||
																		"-" }}
																</v-chip>
															</div>
														</v-layout>
													</v-flex>
												</v-layout>
											</v-card-text>
										</v-card>
									</v-flex>
									<!-- INVOICES SECTION -->
									<v-flex xs12 class="mt-3" v-if="displayedInvoices && displayedInvoices.length">
										<v-card class="c-border br-7" flat>
											<v-card-title class="py-2">
												<span class="subheading fw-semi-bold">{{ $t("lang.invoices") }}</span>
											</v-card-title>

											<v-card-text class="pa-0" style="margin-top: 0px !important">
												<v-list dense class="br-7">
													<v-list-tile v-for="inv in displayedInvoices"
														:key="'invrow-' + inv.invoice_id" class="c-border-bottom"
														style="height: auto !important">
														<v-list-tile-content>
															<v-list-tile-title class="fw-semi-bold">
																<span
																	:class="canOpenInvoice(inv) ? 'clickable-link' : 'disabled-link'"
																	@click="canOpenInvoice(inv) && openInvoicePdf(inv)">
																	{{ inv.invoice_number || "Invoice #" +
																		inv.invoice_id }}
																</span>
															</v-list-tile-title>
															<v-list-tile-sub-title>
																<small>
																	{{ $t("lang.status") }}: {{ inv.status || "-" }} •
																	{{
																		$t("lang.items") }}:
																	{{ inv.item_count || 0 }} • {{ $t("lang.total") }}:
																	${{
																		money(inv.total_amount) }}
																	<span v-if="inv.sent_to_zoho === '1'"> • Zoho: {{
																		$t("lang.synced") }}</span>
																	<span v-else> • Zoho: {{ $t("lang.not_synced")
																	}}</span>
																</small>
															</v-list-tile-sub-title>
														</v-list-tile-content>

														<v-list-tile-action>
															<div style="display: flex; align-items: center; gap: 8px">
																<v-btn small color="error" outline
																	:disabled="!isInvoiceVoidable(inv)"
																	@click="openVoidInvoice(inv)">
																	{{ $t("lang.void") }}
																</v-btn>

																<v-menu offset-y left>
																	<template v-slot:activator="{ on }">
																		<v-btn style="margin-left: 5px !important" icon
																			small v-on="on">
																			<v-icon>more_vert</v-icon>
																		</v-btn>
																	</template>

																	<v-list dense>
																		<v-list-tile v-if="canSyncInvoiceToZoho(inv)"
																			:disabled="!canSyncInvoiceToZoho(inv)"
																			@click="syncInvoiceToZoho(inv)">
																			<v-list-tile-title>
																				{{ inv.sent_to_zoho === "1" ?
																					"Re-sync to Zoho"
																					:
																					"Sync to Zoho" }}
																			</v-list-tile-title>
																		</v-list-tile>

																		<v-list-tile v-if="inv.zoho_invoice_number"
																			@click="copyZohoInvoiceNumber(inv)">
																			<v-list-tile-title>{{
																				$t("lang.copy_zoho_invoice") }}
																				#</v-list-tile-title>
																		</v-list-tile>
																	</v-list>
																</v-menu>
															</div>
														</v-list-tile-action>
													</v-list-tile>
												</v-list>
												<div v-if="hasMoreInvoices" class="pa-2 text-center">
													<v-btn small text @click="invoicesExpanded = !invoicesExpanded">
														{{ invoicesExpanded ? "Show less" : `Show all
														(${selected_subscription_renewal_invoices.length})` }}
													</v-btn>
												</div>
											</v-card-text>
										</v-card>
									</v-flex>

									<!-- MIDDLE SECTION -->
									<v-flex xs12 class="mt-3">
										<v-card class="c-border br-7" flat>
											<v-card-title class="py-2">
												<span class="subheading fw-semi-bold">{{ $t("lang.devices") }}</span>
											</v-card-title>

											<vue-perfect-scrollbar style="max-height: 300px; overflow-y: auto">
												<v-card-text class="pa-0 br-7" style="margin-top: 0px !important">
													<v-list two-line dense class="br-7">
														<!-- PENDING -->
														<v-subheader v-if="pendingItems && pendingItems.length"
															style="display: flex !important; align-items: center !important; justify-content: baseline !important;"
															class="d-flex align-center">
															<v-checkbox class="ma-0 pa-0" dense hide-details
																:input-value="areAllPendingSelected"
																:indeterminate="hasSomePendingSelected && !areAllPendingSelected"
																@click.stop="toggleAllPending"></v-checkbox>
															<span class="ml-1">{{ $t("lang.pending") }}</span>
														</v-subheader>
														<v-list-tile v-for="it in pendingItems"
															:key="'pend-' + it.renewal_item_id" class="c-border-bottom"
															style="height: auto !important">
															<v-list-tile-action>
																<v-checkbox :input-value="isItemSelected(it)"
																	:disabled="it.selection_locked === '1'"
																	@change="toggleItem(it)" hide-details></v-checkbox>
															</v-list-tile-action>

															<v-list-tile-content>
																<v-list-tile-title class="fw-semi-bold">
																	{{ it.device_label || it.display_label || "Device #"
																		+
																		it.device_number }}
																</v-list-tile-title>
																<v-list-tile-sub-title>
																	<small>{{ $t("lang.device_number") }}{{
																		it.device_number }} • {{
																			it.plan_name }} •
																		{{ it.term_months }} mo</small>
																</v-list-tile-sub-title>
															</v-list-tile-content>

															<v-list-tile-action>
																<div class="text-right">
																	<div class="fw-semi-bold">${{ money(it.unit_price)
																	}}</div>
																	<small class="grey--text"
																		v-if="it.selection_locked === '1'">{{
																			$t("lang.locked") }}</small>
																</div>
															</v-list-tile-action>
														</v-list-tile>
														<v-divider></v-divider>

														<!-- INVOICED -->
														<v-subheader v-if="invoicedItems && invoicedItems.length">{{
															$t("lang.invoiced") }}</v-subheader>
														<v-list-tile v-for="it in invoicedItems"
															:key="'inv-' + it.renewal_item_id" class="c-border-bottom"
															style="height: auto !important">
															<v-list-tile-action>
																<v-checkbox :input-value="true" :disabled="true"
																	hide-details></v-checkbox>
															</v-list-tile-action>

															<v-list-tile-content>
																<v-list-tile-title class="fw-semi-bold">
																	{{ it.device_label || it.display_label || "Device #"
																		+
																		it.device_number }}
																</v-list-tile-title>
																<v-list-tile-sub-title>
																	<small>
																		{{ $t("lang.device_number") }}{{
																			it.device_number }} • {{
																			it.plan_name }} •
																		{{ it.term_months }} mo
																		<span v-if="it.invoice_number"> • {{
																			it.invoice_number
																		}}</span>
																	</small>
																</v-list-tile-sub-title>
															</v-list-tile-content>

															<v-list-tile-action>
																<div class="text-right">
																	<div class="fw-semi-bold">${{ money(it.unit_price)
																	}}</div>
																	<small class="grey--text">{{ $t("lang.invoiced")
																	}}</small>
																</div>
															</v-list-tile-action>
														</v-list-tile>

														<!-- REMAINING -->
														<v-subheader v-if="remainingItems && remainingItems.length"
															class="d-flex align-center">
															<v-checkbox class="ma-0 pa-0" dense hide-details
																:input-value="areAllRemainingSelected"
																:indeterminate="hasSomeRemainingSelected && !areAllRemainingSelected"
																@click.stop="toggleAllRemaining"></v-checkbox>
															<span class="ml-1">{{ $t("lang.remaining") }}</span>
														</v-subheader>
														<v-list-tile v-for="it in remainingItems"
															:key="'rem-' + it.renewal_item_id" class="c-border-bottom"
															style="height: auto !important">
															<v-list-tile-action>
																<v-checkbox :input-value="isItemSelected(it)"
																	:disabled="it.selection_locked === '1' || !(it.can_invoice === true || it.can_invoice === '1')"
																	@change="toggleItem(it)" hide-details></v-checkbox>
															</v-list-tile-action>

															<v-list-tile-content>
																<v-list-tile-title class="fw-semi-bold">
																	{{ it.device_label || it.display_label || "Device #"
																		+
																		it.device_number }}
																</v-list-tile-title>
																<v-list-tile-sub-title>
																	<small>
																		{{ $t("lang.device_number") }}{{
																			it.device_number }} • {{
																			it.plan_name }} •
																		{{ it.term_months }} mo
																	</small>
																</v-list-tile-sub-title>
															</v-list-tile-content>

															<v-list-tile-action>
																<div class="text-right">
																	<div class="fw-semi-bold">${{ money(it.unit_price)
																	}}</div>
																	<small class="grey--text"
																		v-if="it.selection_locked === '1'">{{
																			$t("lang.locked") }}</small>
																</div>
															</v-list-tile-action>
														</v-list-tile>

														<!-- EMPTY STATE -->
														<v-list-tile v-if="
															(!pendingItems || pendingItems.length === 0) &&
															(!invoicedItems || invoicedItems.length === 0) &&
															(!remainingItems || remainingItems.length === 0)
														">
															<v-list-tile-content>
																<v-list-tile-title class="grey--text">{{
																	$t("lang.no_devices_found")
																}}</v-list-tile-title>
															</v-list-tile-content>
														</v-list-tile>
													</v-list>
												</v-card-text>
											</vue-perfect-scrollbar>
										</v-card>
									</v-flex>

									<!-- BOTTOM SECTION -->
									<v-flex xs12 class="mt-3">
										<v-card class="c-border br-7" flat>
											<v-card-text class="py-3" style="margin-top: 0px !important">
												<v-layout row wrap align-center>
													<v-flex xs12 sm6>
														<div class="subheading">
															<span class="fw-semi-bold">{{ $t("lang.selected") }}:</span>
															{{ selectedCount }} {{ $t("lang.of") }} {{ totalCount }} {{
																$t("lang.devices") }}
														</div>
													</v-flex>

													<v-flex xs12 sm6 class="text-sm-right">
														<div class="subheading">
															<span class="fw-semi-bold">{{ $t("lang.total") }}:</span>
															${{ money(selectedTotal) }}
														</div>
													</v-flex>
												</v-layout>
											</v-card-text>
										</v-card>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-text>
						<v-card-actions v-if="showRenewalActions">
							<v-spacer></v-spacer>
							<v-btn color="success" @click="confirmAndCreateInvoice" :disabled="!canCreateInvoice"
								v-if="hasPerm('subscriptions.update')">
								{{ $t("lang.confirm_and_create_invoice") }}
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-card>
			</bc-dialog>
			<bc-dialog :value="invoice_created_dialog" max-width="600">
				<v-card>
					<v-card-title class="headline">
						{{ $t("lang.invoice_created") }}
						<v-spacer></v-spacer>
						<v-btn icon @click="invoice_created_dialog = false">
							<v-icon>close</v-icon>
						</v-btn>
					</v-card-title>

					<v-card-text>
						<div class="mb-2">
							<span class="fw-semi-bold">{{ $t("lang.invoice") }}:</span>
							{{ (subscription_renewal_confirm_result &&
								subscription_renewal_confirm_result.invoice_number) || "-" }}
						</div>

						<div>
							<span class="fw-semi-bold">{{ $t("lang.total") }}:</span>
							${{ money(subscription_renewal_confirm_result &&
								subscription_renewal_confirm_result.total_amount) }}
						</div>
					</v-card-text>

					<v-card-actions>
						<v-btn color="primary" @click="onViewInvoice"
							:disabled="!(subscription_renewal_confirm_result && subscription_renewal_confirm_result.invoice_id)">
							{{ $t("lang.view_invoice") }}
						</v-btn>

						<!-- <v-btn
							color="success"
							@click="onSyncToZoho"
							:disabled="!(subscription_renewal_confirm_result && subscription_renewal_confirm_result.invoice_id)"
						>
							{{ $t("lang.sync_to") }} Zoho
						</v-btn> -->

						<v-spacer></v-spacer>
						<v-btn flat @click="backToKanban">{{ $t("lang.back_to_kanban") }}</v-btn>
					</v-card-actions>
				</v-card>
			</bc-dialog>
			<bc-dialog :value="void_invoice_dialog">
				<v-card>
					<v-card-title class="headline">
						{{ $t("lang.void_invoice") }}
						<v-spacer></v-spacer>
						<v-btn icon @click="void_invoice_dialog = false"><v-icon>close</v-icon></v-btn>
					</v-card-title>

					<v-card-text>
						<div class="mb-3">
							<div class="fw-semi-bold">
								{{ (void_invoice_target && void_invoice_target.invoice_number) || "-" }}
							</div>
							<small class="grey--text">{{ $t("lang.this_will_release_items_back_to_pending_remaining")
							}}</small>
						</div>

						<v-text-field v-model="void_invoice_reason" label="Reason" />
					</v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn flat @click="void_invoice_dialog = false" :disabled="isVoiding">{{ $t("lang.cancel")
						}}</v-btn>
						<v-btn color="error" @click="confirmVoidInvoice" :disabled="isVoiding">{{
							$t("lang.void_invoice") }}</v-btn>
					</v-card-actions>
				</v-card>
			</bc-dialog>
			<bc-dialog :value="pdf_viewer_dialog" :max-width="950">
				<v-card>
					<v-card-title class="headline">
						{{ pdf_viewer_title }}
						<v-spacer></v-spacer>
						<v-btn icon @click="closePdfViewer"><v-icon>close</v-icon></v-btn>
					</v-card-title>

					<v-card-text style="padding: 0; height: 80vh">
						<iframe :src="pdf_viewer_url" style="width: 100%; height: 80vh; border: 0" />
					</v-card-text>
				</v-card>
			</bc-dialog>

			<bc-dialog :value="subscription_dialog_table">
				<v-card>
					<v-form ref="form_subscription">
						<v-card-title>
							<span class="headline">{{ subscription.subscription_id ? $t("lang.edit_subscription") :
								$t("lang.add_subscription") }}</span>
							<v-spacer></v-spacer>
							<bc-btn-dialog-close @invoke-method="invokeMethod($event)"
								action="closeSubscriptionTableDialog"
								:dialog-status="subscription_dialog_table"></bc-btn-dialog-close>
						</v-card-title>
						<v-card-text>
							<v-container grid-list-form>
								<v-layout row wrap>
									<v-flex xs12>
										<bc-autocomplete v-model="subscription.device_id"
											:label="`${$t('lang.device')}`" :items="formattedDeviceOptions"
											item-value="device_id" item-text="displayText"
											:rules="ifValid('subscriptions.device_id')"
											:disabled="!hasPerm('subscriptions.update')"></bc-autocomplete>
									</v-flex>
									<v-flex xs12>
										<v-text-field v-model="subscription.amount" :label="`${$t('lang.amount')} *`"
											:counter="showCounter(subscription.amount, 'subscriptions.amount')"
											:rules="ifValid('subscriptions.amount')"
											:disabled="!hasPerm('subscriptions.update')"></v-text-field>
									</v-flex>
									<v-flex xs12>
										<bc-select v-model="subscription.term_length"
											:label="`${$t('lang.term_length')} *`" :items="term_lengths"
											item-value="value" item-text="option"
											:rules="ifValid('subscriptions.term_length')"
											:disabled="!hasPerm('subscriptions.update')"></bc-select>
									</v-flex>
									<v-flex xs12>
										<bc-date-picker v-model="subscription.period_start"
											:label="`${$t('lang.period_start')} *`"
											:rules="ifValid('subscriptions.period_start')"
											:disabled="!hasPerm('subscriptions.update')"></bc-date-picker>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-btn v-if="subscription.subscription_id && hasPerm('subscriptions.delete')" color="error"
								@mouseup.left="$refs.delete_subscriptions.openDialog()">{{ $t("lang.delete") }}
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn flat @mouseup.left="closeSubscriptionTableDialog()">{{ $t("lang.cancel") }}</v-btn>
							<v-btn color="success" @click="saveSubscriptions" v-if="hasPerm('subscriptions.update')">{{
								$t("lang.save") }}</v-btn>
						</v-card-actions>
					</v-form>
				</v-card>
			</bc-dialog>

			<delete-confirmation-dialog ref="delete_subscriptions" :heading="$t('lang.delete_subscription')"
				:message="$t('lang.confirm_delete_message')"
				@onConfirm="deleteSubscriptions(subscription.subscription_id)"></delete-confirmation-dialog>
		</v-container>
	</div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import httpClient from "Api/httpClient";
import _ from "lodash";

export default {
	data() {
		return {
			mobile_list: [{ title: this.$t("lang.refresh"), action: "dbGetSubscriptions", params: [true] }],
			headers: [
				{ text: this.$t("lang.device_number"), value: "public_id", sortable: false, width: "3%" },
				{ text: this.$t("lang.company"), value: "company_name", sortable: false, width: "10%" },
				{ text: this.$t("lang.amount"), value: "amount", sortable: false, width: "4%" },
				{ text: this.$t("lang.term"), value: "term_length", sortable: false, width: "4%", align: "center" },
				{ text: this.$t("lang.period_start"), value: "period_start", sortable: false, width: "7%", align: "center" },
				{ text: this.$t("lang.period_end"), value: "period_end", sortable: false, width: "7%", align: "center" },
				{ text: this.$t("lang.status"), value: "status", sortable: false, width: "7%", align: "center" },
			],

			enableAddModal: true,
			enableEditModal: true,
			subscription: {
				public_id: null,
				company: null,
				status: null,
				device_id: null,
				amount: null,
				term_length: null,
				period_start: null,
				period_end: null,
				is_verified: null,
				zoho_invoice_id: null,
				subscription_id: null,
			},
			filter: {
				search: "",
				bucket: null,
				status: "active",
				company_id: "",
				account_id: "",
			},
			subscription_dialog: false,
			add_subscription_dialog: false,
			dbGetSubscriptions: _.debounce(this.getSubscriptions, 1500, { maxWait: 1500, leading: true, trailing: false }),
			loading: true,
			select_zoho_invoice_dialog: false,
			zoho_invoice_headers: [
				{ text: this.$t("lang.device_number"), sortable: false, width: "33%" },
				{ text: this.$t("lang.label"), sortable: false, width: "33%" },
				{ text: this.$t("lang.account"), sortable: false, width: "33%" },
			],
			billedSubscriptions: [],
			upcomingSubscriptions: [],
			suspendedSubscriptions: [],
			cancelledSubscriptions: [],
			overdueSubscriptions: [],
			table_view: null,
			mark_as_paid_items: [],
			mark_as_billed_items: [],
			selected_invoice: null,
			term_length: null,
			subscriptions: [],
			textSearch: "",
			searchStatus: "active",
			bucketOptions: [
				{ value: "upcoming", option: this.$t("lang.upcoming") },
				{ value: "billed", option: this.$t("lang.billed") },
				{ value: "overdue", option: this.$t("lang.overdue") },
				{ value: "suspended", option: this.$t("lang.suspended") },
				{ value: "canceled", option: this.$t("lang.canceled") },
			],
			company_options: [],
			account_options: [],
			invoice_created_dialog: false,
			void_invoice_dialog: false,
			void_invoice_reason: "Customer selected wrong devices",
			void_invoice_target: null,
			pdf_viewer_dialog: false,
			pdf_viewer_url: null,
			pdf_viewer_title: "Invoice",
			pdf_loading: false,
			invoicesExpanded: false,
			invoicesPreviewLimit: 5,
			isVoiding: false,
			subscription_dialog_table: false,
		};
	},
	computed: {
		currentView() {
			return this.$route.query.view || "kanban";
		},
		...mapState({
			default_filter: (state) => state.subscriptions.subscriptions_filter,
			page: (state) => state.subscriptions.page,
			rules_subscriptions: (state) => state.subscriptions.rules_subscriptions,
			subscription_status_options: (state) => state.settings.subscription_status_options,
			device_options: (state) => state.devices.device_options,
			customer_options: (state) => state.customers.customer_options,
			term_lengths: (state) => state.options_categories.term_lengths,
			companies: (state) => state.customers,
			kanban: (state) => state.subscriptions.kanban,
			kanban_summary: (state) => state.subscriptions.kanban_summary,
			subscription_plans: (state) => state.subscription_plans.subscription_plan_options,
			selected_subscription_renewal: (state) => state.subscriptions.selected_subscription_renewal,
			selected_subscription_renewal_items_grouped: (state) => state.subscriptions.selected_subscription_renewal_items_grouped,
			selected_subscription_renewal_invoices: (state) => state.subscriptions.selected_subscription_renewal_invoices,

			selected_subscription_renewal_summary: (state) => state.subscriptions.selected_subscription_renewal_summary,
			subscription_renewal_confirm_result: (state) => state.subscriptions.subscription_renewal_confirm_result,
		}),
		selectedUpcomingSubscriptions() {
			return this.mark_as_billed_items;
		},
		formattedDeviceOptions() {
			return this.device_options.map((device) => ({
				...device,
				displayText: device.company ? `${device.public_id} - ${device.company}` : `${device.public_id}`,
			}));
		},
		filteredSubscriptions() {
			const search = this.textSearch ? this.textSearch.toLowerCase() : "";
			return this.subscriptions.filter((sub) => {
				if (Array.isArray(this.filter.bucket) && this.filter.bucket.length > 0 && !this.filter.bucket.includes(sub.bucket)) return false;

				if (
					this.filter.company_id &&
					(Array.isArray(this.filter.company_id)
						? this.filter.company_id.length > 0 && !this.filter.company_id.includes(sub.company_id)
						: sub.company_id !== this.filter.company_id)
				)
					return false;

				if (this.filter.account_id && sub.account_id !== this.filter.account_id) return false;
				if (this.filter.status && sub.status !== this.filter.status) return false;

				if (search) {
					const values = Object.values(sub)
						.filter((v) => v !== null && v !== undefined)
						.map((v) => v.toString().toLowerCase());
					if (!values.some((val) => val.includes(search))) return false;
				}

				return true;
			});
		},
		filteredBuckets() {
			const search = this.textSearch ? this.textSearch.toLowerCase() : "";
			let bucketsToShow = this.subscriptionBuckets;

			const bucketTitleToValue = (title) => {
				const map = {
					[this.$t("lang.upcoming")]: "upcoming",
					[this.$t("lang.billed")]: "billed",
					[this.$t("lang.overdue")]: "overdue",
					[this.$t("lang.suspended")]: "suspended",
					[this.$t("lang.canceled")]: "canceled",
				};
				return map[title];
			};

			if (Array.isArray(this.filter.bucket) && this.filter.bucket.length > 0) {
				bucketsToShow = this.subscriptionBuckets.filter((bucket) => this.filter.bucket.indexOf(bucketTitleToValue(bucket.title)) !== -1);
			}

			return bucketsToShow.map((bucket) => ({
				...bucket,
				items: bucket.items.filter((item) => {
					if (
						this.filter.company_id &&
						(Array.isArray(this.filter.company_id)
							? this.filter.company_id.length > 0 && !this.filter.company_id.includes(item.company_id)
							: item.company_id !== this.filter.company_id)
					)
						return false;
					if (search) {
						const values = Object.values(item)
							.filter((v) => v !== null && v !== undefined)
							.map((v) => v.toString().toLowerCase());
						if (!values.some((val) => val.includes(search))) return false;
					}
					return true;
				}),
			}));
		},
		filteredUpcomingSubscriptions() {
			return this.subscriptions.filter((item) => item.bucket === "upcoming");
		},
		axiosParams() {
			return this.prepareParams(this.filter, this.default_filter);
		},

		subscriptionBuckets() {
			const kanban = this.kanban || {};
			return [
				{
					key: "upcoming",
					title: this.$t("lang.upcoming"),
					subtitle: "31 - 60 " + this.$t("lang.days"),
					color: "#bbdefb80",
					items: kanban.upcoming || [],
				},
				{
					key: "billed",
					title: this.$t("lang.billed"),
					subtitle: "0 - 30 " + this.$t("lang.days"),
					color: "#c8e6c980",
					items: kanban.billed || [],
				},
				{
					key: "overdue",
					title: this.$t("lang.overdue"),
					subtitle: "1 - 45 " + this.$t("lang.days"),
					color: "#ffcdd280",
					items: kanban.overdue || [],
				},
				{
					key: "suspended",
					title: this.$t("lang.suspended"),
					subtitle: "46 - 60 " + this.$t("lang.days"),
					color: "#ffecb380",
					items: kanban.suspended || [],
				},
				{
					key: "canceled",
					title: this.$t("lang.canceled"),
					subtitle: "61-90 " + this.$t("lang.days"),
					color: "#e0e0e080",
					items: kanban.canceled || [],
				},
			];
		},
		totalSubscriptionCount() {
			if (!this.table_view) {
				return this.filteredSubscriptions.length;
			}

			if (!this.kanban_summary) return 0;

			var keys = ["upcoming", "billed", "overdue", "suspended", "canceled"];
			var total = 0;

			for (var i = 0; i < keys.length; i++) {
				var k = keys[i];
				if (this.kanban_summary[k] && this.kanban_summary[k].device_count !== undefined && this.kanban_summary[k].device_count !== null) {
					var n = Number(this.kanban_summary[k].device_count);
					total += isNaN(n) ? 0 : n;
				}
			}

			return total;
		},
		pendingItems() {
			const g = this.selected_subscription_renewal_items_grouped || {};
			return g.pending || [];
		},
		invoicedItems() {
			const g = this.selected_subscription_renewal_items_grouped || {};
			return g.invoiced || [];
		},
		remainingItems() {
			const g = this.selected_subscription_renewal_items_grouped || {};
			return g.remaining || [];
		},

		areAllPendingSelected() {
			const items = (this.pendingItems || []).filter((it) => it && it.selection_locked !== "1");
			if (!items.length) return false;
			return items.every((it) => it.selected_for_renewal === "1");
		},
		hasSomePendingSelected() {
			const items = (this.pendingItems || []).filter((it) => it && it.selection_locked !== "1");
			return items.some((it) => it.selected_for_renewal === "1");
		},
		areAllRemainingSelected() {
			const items = (this.remainingItems || []).filter(
				(it) =>
					it &&
					it.selection_locked !== "1" &&
					(it.can_invoice === true || it.can_invoice === "1"),
			);
			if (!items.length) return false;
			return items.every((it) => it.selected_for_renewal === "1");
		},
		hasSomeRemainingSelected() {
			const items = (this.remainingItems || []).filter(
				(it) =>
					it &&
					it.selection_locked !== "1" &&
					(it.can_invoice === true || it.can_invoice === "1"),
			);
			return items.some((it) => it.selected_for_renewal === "1");
		},

		showRenewalActions() {
			const items = this.selectableItems || [];
			return items.some(
				(it) => it && it.selection_locked !== "1" && (it.can_invoice === true || it.can_invoice === "1" || it.lifecycle_status === "pending"),
			);
		},

		canCreateInvoice() {
			return this.selectedBillableIds.length > 0;
		},
		selectableItems() {
			return [...(this.pendingItems || []), ...(this.remainingItems || [])];
		},
		totalCount() {
			return this.selectableItems.length;
		},
		selectedCount() {
			return this.selectableItems.filter((it) => it && it.selected_for_renewal === "1").length;
		},
		selectedTotal() {
			return this.selectableItems.reduce((sum, it) => {
				if (!it || it.selected_for_renewal !== "1") return sum;
				const n = Number(it.unit_price);
				return sum + (isNaN(n) ? 0 : n);
			}, 0);
		},
		selectedBillableIds() {
			return (this.selectableItems || [])
				.filter((it) => it && it.selected_for_renewal === "1")
				.filter((it) => it && it.selection_locked !== "1")
				.filter((it) => it && (it.can_invoice === true || it.can_invoice === "1" || it.lifecycle_status === "pending"))
				.map((it) => Number(it.renewal_item_id));
		},
		displayedInvoices() {
			const invoices = this.selected_subscription_renewal_invoices || [];
			if (this.invoicesExpanded) return invoices;
			return invoices.slice(0, this.invoicesPreviewLimit);
		},
		hasMoreInvoices() {
			const invoices = this.selected_subscription_renewal_invoices || [];
			return invoices.length > this.invoicesPreviewLimit;
		},
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.loading = true;
			_.delay(() => {
				vm.$store.commit("toggleMainMenu", false);

				if (to.query.view !== "list") {
					vm.getKanbanSubscriptions();
				} else {
					vm.getSubscriptions();
				}

				vm.getCompanies();
			}, 500);
		});
	},
	beforeRouteUpdate(to, from, next) {
		this.loading = true;

		const parsedQuery = { ...to.query, options: "1" };

		_.delay(() => {
			this.$store.commit("toggleMainMenu", false);
			this.fetchSubscriptions({
				body: JSON.parse(JSON.stringify(parsedQuery)),
			}).then((data) => {
				if (typeof data !== "undefined" && data.subscriptions) {
					this.setQuery(parsedQuery, this.filter, this.default_filter);
					this.subscriptions = data.subscriptions;
					this.finishLoader();
					this.loading = false;
					next();
				} else {
					next({ name: "dashboard", replace: true });
				}
			});
		}, 500);
	},
	methods: {
		...mapActions([
			"fetchSubscriptions",
			"fetchSubscription",
			"saveSubscription",
			"deleteSubscription",
			"fetchCustomers",
			"fetchDevices",
			"fetchOptions",
			"fetchKanban",
			"fetchSubscriptionPlans",
			"fetchSubscriptionRenewal",
			"createSubscriptionRenewalInvoice",
			"voidSubscriptionInvoice",
			"fetchSubscriptionInvoicePdf",
			"syncSubscriptionInvoiceToZoho",
		]),
		...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader", "clearSubscriptions", "toggleSubscriptionRenewalItem"]),
		refreshCurrentView(pg_refresh = false) {
			if (this.table_view) return this.getKanbanSubscriptions(pg_refresh);
			return this.getSubscriptions(pg_refresh);
		},
		openSubscriptionTableForm(item = null) {
			if (this.customer_options.length == 0) {
				this.fetchCustomers({ body: { options: 1 } });
			}
			if (this.term_lengths.length <= 0) {
				this.fetchOptions({ body: { slug: "term_lengths" } });
			}
			if (this.device_options.length === 0) {
				this.fetchDevices({ body: { options: "1" } });
			}
			if (item != null) {
				if (this.enableEditModal) {
					if (this.$refs.form_subscription) item ? this.$refs.form_subscription.resetValidation() : this.$refs.form_subscription.reset();

					this.$nextTick(() => {
						this.subscription = item != null ? this.assignObj2(item, this.rules_subscriptions) : {};
						this.subscription_dialog_table = true;
					});
				} else {
					this.$router.push({ name: "subscription", params: { subscription_id: item.subscription_id } });
				}
			} else {
				if (this.enableAddModal) {
					if (this.$refs.form_subscription) item ? this.$refs.form_subscription.resetValidation() : this.$refs.form_subscription.reset();
					this.subscription_dialog_table = true;
				} else {
					this.$router.push({ name: "subscription" });
				}
			}
		},
		closeSubscriptionTableDialog() {
			this.subscription_dialog_table = false;
			this.subscription = {};
			this.validationOff();
			this.toggleModalLoader(false);
		},
		getBucketDeviceCount(bucket) {
			if (!this.table_view) return 0;
			if (!bucket || !bucket.key) return 0;
			if (!this.kanban_summary) return 0;
			if (!this.kanban_summary[bucket.key]) return 0;

			var raw = this.kanban_summary[bucket.key].device_count;
			var num = Number(raw);
			return isNaN(num) ? 0 : num;
		},
		getBucketSubscriptionCount(bucket) {
			if (!this.table_view) return 0;
			if (!bucket || !bucket.key) return 0;
			if (!this.kanban_summary) return 0;
			if (!this.kanban_summary[bucket.key]) return 0;

			var raw = this.kanban_summary[bucket.key].device_count;
			var num = Number(raw);
			return isNaN(num) ? 0 : num;
		},

		async openSubscriptionForm(item = null) {
			if (item != null) {
				this.subscription_dialog = true;
				this.toggleModalLoader(true);
				try {
					this.invoicesExpanded = false;
					await this.fetchSubscriptionRenewal({ renewal_period_id: item.renewal_period_id });
				} finally {
					this.toggleModalLoader(false);
				}
			} else {
				// handle add
			}
		},
		saveSubscriptions() {
			this.validationOn();
			this.$nextTick(() => {
				if (this.validateForm("form_subscription")) {
					let body = this.prepForm(this.subscription, this.rules_subscriptions);
					delete body["notes"];

					this.saveSubscription({
						body: body,
					}).then((data) => {
						if (data && data.code == "200") {
							if (this.table_view) {
								this.getKanbanSubscriptions();
							} else {
								this.getSubscriptions();
							}
							this.closeSubscriptionTableDialog();
						}
					});
				}
			});
		},
		deleteSubscriptions(subscription_id = null) {
			this.deleteSubscription({
				subscription_id: subscription_id,
			}).then((data) => {
				if (data && data.code == "200") {
					if (this.table_view) {
						this.getKanbanSubscriptions();
					} else {
						this.getSubscriptions();
					}
				} else {
					this.toggleModalLoader(false);
				}
			});
			this.closeSubscriptionDialog();
		},
		closeSubscriptionDialog() {
			this.subscription_dialog = false;
			this.add_subscription_dialog = false;
			this.subscription.subscription_id = null;
			this.$refs.delete_subscriptions.close();
			this.subscription = {};
			this.validationOff();
			this.toggleModalLoader(false);
		},
		async getSubscriptions(pg_refresh = false) {
			this.startLoader();
			this.loading = true;

			try {
				let query = {
					...this.$route.query,
					options: "1",
				};

				const data = await this.$store.dispatch("fetchSubscriptions", {
					body: JSON.parse(JSON.stringify(query)),
				});

				if (!data) {
					this.$router.push({ name: "dashboard" });
					return;
				}

				this.subscriptions = data.subscriptions || [];
			} finally {
				this.subscription_dialog = false;
				this.getCompanies();
				this.toggleModalLoader(false);
				this.validationOff();
				this.finishLoader(pg_refresh);
				this.loading = false;
			}
		},
		async getKanbanSubscriptions(pg_refresh = false) {
			this.startLoader();
			this.loading = true;

			try {
				let body = {};
				if (this.filter.account_id) {
					body.account_id = this.filter.account_id;
				}
				await this.fetchKanban({ body: body });
			} finally {
				this.toggleModalLoader(false);
				this.finishLoader(pg_refresh);
				this.loading = false;
			}
		},
		changeView() {
			this.textSearch = "";
			this.table_view = !this.table_view;
			this.setView(this.table_view ? "kanban" : "list");

			if (this.table_view) {
				this.getKanbanSubscriptions();
			} else {
				this.getSubscriptions();
			}
		},
		setView(viewType) {
			this.$router.push({
				query: {
					...this.$route.query,
					view: viewType,
				},
			});
		},
		exportToCsv() {
			// keep export columns in the SAME ORDER as the UI table
			const exportColumns = [
				{ title: this.$t("lang.device_number"), key: "public_id" },
				{ title: this.$t("lang.provider"), key: "mobile_provider" },
				{ title: this.$t("lang.firmware"), key: "firmware_version" },
				{ title: this.$t("lang.company"), key: "company_name" },
				{ title: this.$t("lang.amount"), key: "amount", format: (v) => (v != null ? Number(v).toFixed(2) : "") },
				{ title: this.$t("lang.term"), key: "term_length" },
				{ title: this.$t("lang.period_start"), key: "period_start" },
				{ title: this.$t("lang.period_end"), key: "period_end" },
				{ title: this.$t("lang.status"), key: "status" },
			];

			const headers = exportColumns.map((c) => c.title);

			const rows = this.filteredSubscriptions.map((item) =>
				exportColumns.map((c) => {
					const raw = item ? item[c.key] : "";
					return c.format ? c.format(raw, item) : raw == null ? "" : raw;
				}),
			);

			const csvContent = [headers.map(this.csvEscape).join(","), ...rows.map((r) => r.map(this.csvEscape).join(","))].join("\n");

			const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
			const url = URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "subscriptions.csv");
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(url);
		},

		csvEscape(val) {
			const s = val == null ? "" : String(val);
			return `"${s.replace(/"/g, '""')}"`;
		},

		async getCompanies() {
			let response = await httpClient.get("/companies?options=1&organisation_type_slug[]=customer", { retryTimes: 3 });
			if (response.data.companies) {
				this.company_options = response.data.companies;
			}
		},
		async getAccounts() {
			let response = await httpClient.get("/accounts?options=1", { retryTimes: 3 });
			if (response.data.accounts) {
				this.account_options = response.data.accounts;
			}
		},
		async confirmAndCreateInvoice() {
			this.toggleModalLoader(true);
			try {
				var renewal_period_id = this.selected_subscription_renewal.renewal_period_id;

				var res = await this.createSubscriptionRenewalInvoice({
					renewal_period_id: renewal_period_id,
					renewal_item_ids: this.selectedBillableIds,
				});

				if (res && Number(res.code) === 200) {
					this.invoice_created_dialog = true;

					await this.fetchSubscriptionRenewal({ renewal_period_id: renewal_period_id });
				}
			} finally {
				this.toggleModalLoader(false);
			}
		},

		isItemSelected(it) {
			return it && it.selected_for_renewal === "1";
		},

		toggleItem(it) {
			if (!it) return;

			if (it.selection_locked === "1") return;

			this.$store.commit("toggleSubscriptionRenewalItem", {
				renewal_item_id: it.renewal_item_id,
			});
		},

		toggleAllPending() {
			const items = (this.pendingItems || []).filter((it) => it && it.selection_locked !== "1");
			if (!items.length) return;

			const allSelected = items.every((it) => it.selected_for_renewal === "1");
			items.forEach((it) => {
				const isSelected = it.selected_for_renewal === "1";
				const shouldSelect = !allSelected;
				if (isSelected !== shouldSelect) {
					this.$store.commit("toggleSubscriptionRenewalItem", {
						renewal_item_id: it.renewal_item_id,
					});
				}
			});
		},

		toggleAllRemaining() {
			const items = (this.remainingItems || []).filter(
				(it) =>
					it &&
					it.selection_locked !== "1" &&
					(it.can_invoice === true || it.can_invoice === "1"),
			);
			if (!items.length) return;

			const allSelected = items.every((it) => it.selected_for_renewal === "1");
			items.forEach((it) => {
				const isSelected = it.selected_for_renewal === "1";
				const shouldSelect = !allSelected;
				if (isSelected !== shouldSelect) {
					this.$store.commit("toggleSubscriptionRenewalItem", {
						renewal_item_id: it.renewal_item_id,
					});
				}
			});
		},

		money(val) {
			var n = Number(val);
			if (isNaN(n)) n = 0;
			return n.toFixed(2);
		},

		formatDate(dateStr) {
			return dateStr || "-";
		},

		statusColor(status) {
			if (!status) return "grey";
			if (status === "upcoming") return "primary";
			if (status === "pending") return "orange";
			if (status === "overdue") return "red";
			if (status === "billed") return "success";
			if (status === "canceled") return "grey darken-1";
			return "blue-grey";
		},
		onViewInvoice() {
			var r = this.subscription_renewal_confirm_result;
			if (!r || !r.invoice_id) return;
			this.openInvoicePdf({ invoice_id: r.invoice_id, invoice_number: r.invoice_number });
		},

		async onSyncToZoho() {
			var r = this.subscription_renewal_confirm_result;
			if (!r || !r.invoice_id) return;

			// mimic invoice row shape
			await this.syncInvoiceToZoho({
				invoice_id: r.invoice_id,
				invoice_number: r.invoice_number,
				status: r.status || "",
				sent_to_zoho: r.sent_to_zoho || "0",
				zoho_invoice_id: r.zoho_invoice_id,
				zoho_invoice_number: r.zoho_invoice_number,
			});
		},
		async syncInvoiceToZoho(inv) {
			if (!inv || !inv.invoice_id) return;

			this.toggleModalLoader(true);
			try {
				var renewal_period_id = this.selected_subscription_renewal && this.selected_subscription_renewal.renewal_period_id;

				var res = await this.syncSubscriptionInvoiceToZoho({
					invoice_id: inv.invoice_id,
					force: 1,
					renewal_period_id: renewal_period_id,
				});
			} finally {
				this.toggleModalLoader(false);
			}
		},

		backToKanban() {
			this.invoice_created_dialog = false;
			this.subscription_dialog = false;

			this.table_view = true;
			this.setView("kanban");
			this.getKanbanSubscriptions(true);
		},
		openVoidInvoice(invoice) {
			this.void_invoice_target = invoice;
			this.void_invoice_reason = "";
			this.void_invoice_dialog = true;
		},

		async confirmVoidInvoice() {
			if (!this.void_invoice_target) return;
			if (this.isVoiding) return;

			this.isVoiding = true;
			this.toggleModalLoader(true);
			try {
				const res = await this.voidSubscriptionInvoice({
					invoice_id: this.void_invoice_target.invoice_id,
					renewal_period_id: this.selected_subscription_renewal.renewal_period_id,
					reason: this.void_invoice_reason,
				});

				if (res && Number(res.code) === 200) {
					this.void_invoice_dialog = false;
					this.void_invoice_target = null;
				}
			} finally {
				this.toggleModalLoader(false);
				this.isVoiding = false;
			}
		},

		isInvoiceVoidable(inv) {
			if (!inv) return false;
			var s = (inv.status || "").toLowerCase();
			return s !== "void";
		},
		closePdfViewer() {
			this.pdf_viewer_dialog = false;
			this.pdf_viewer_url = null;
			this.pdf_viewer_title = "Invoice";
		},

		async openInvoicePdf(invoice) {
			if (!this.canOpenInvoice(invoice)) return;

			var invoice_id = invoice && invoice.invoice_id;
			if (!invoice_id) return;

			this.toggleModalLoader(true);
			this.pdf_viewer_title = invoice && invoice.invoice_number ? invoice.invoice_number : "Invoice";

			try {
				var res = await this.fetchSubscriptionInvoicePdf({ invoice_id: invoice_id });
				this.pdf_viewer_dialog = true;
				if (res && res.pdf_url) {
					this.pdf_viewer_url = res.pdf_url;
				}
			} finally {
				this.toggleModalLoader(false);
				this.pdf_loading = false;
			}
		},
		canSyncInvoiceToZoho(inv) {
			if (!inv || !inv.invoice_id || !this.hasPerm("subscriptions.zoho_sync")) return false;

			var s = (inv.status || "").toLowerCase();
			if (s === "void") return false;

			return true;
		},
		viewZohoInvoice(inv) {
			var txt = inv.zoho_invoice_number || inv.zoho_invoice_id;
			if (!txt) return;
		},
		copyZohoInvoiceNumber(inv) {
			var txt = inv.zoho_invoice_number || "";
			if (!txt) return;

			try {
				if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(txt);
				}
			} catch (e) { }
		},
		canOpenInvoice(inv) {
			if (!inv || !inv.invoice_id) return false;

			// optional: don't allow viewing voided invoices
			const s = (inv.status || "").toLowerCase();
			if (s === "void") return false;

			return true;
		},
	},
	watch: {
		$route(to, from) {
			this.table_view = to.query.view !== "list";
		},
		"filter.account_id": function () {
			if (this.table_view) {
				this.getKanbanSubscriptions();
			}
		},
	},
	beforeRouteLeave(to, from, next) {
		this.$store.commit("clearSubscriptions");
		next();
	},
	created() {
		this.table_view = this.$route.query.view !== "list";
	},
};
</script>

<style>
.tile-height-auto>div {
	height: auto !important;
}

.status-chip {
	display: inline-flex;
	/* prevents it from behaving like a full-width block */
	width: auto;
	max-width: 160px;
	/* optional: keeps it from getting huge */
	justify-content: center;
}

.clickable-link {
	cursor: pointer;
	text-decoration: underline;
}

.disabled-link {
	cursor: default;
	text-decoration: none;
	opacity: 0.55;
}

#inspire>div.application--wrap>div.app-default-layout>main>div>div>div>div.container.ma-0>div>div.v-card__text>div>div:nth-child(2)>div>div>div>div>section>div.mb-3.pb-2.c-border-bottom>div {
	height: auto !important;
}

.chip-row {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	margin-top: 4px;
}

/* hard-stop any stretching */
.chip-inline {
	width: auto !important;
	max-width: 100%;
	display: inline-flex !important;
	flex: 0 0 auto !important;
	align-self: flex-start;
}
</style>
